export default {
	title: "Usuarios",
	email: "Correo electrónico",
	role: "Rol",
	adminUsers: "Administradores",
	confirmRemove: "Confirmar Eliminación",
	confirmRemoveMessage: "¿Está seguro de que desea eliminar a {name} del templo?",
	createdAt: "Creado en",
	displayName: "Nombre",
	inviteUser: "Invitar Usuario",
	memberUsers: "Miembros",
	ownerUsers: "Propietarios",
	removeError: "Error al eliminar usuario",
	removeSuccess: "Usuario eliminado con éxito",
	ritualFunction: "Función Ritual",
	roleChangeError: "Error al cambiar rol",
	roleChangeSuccess: "Rol actualizado con éxito",
	totalUsers: "Total de usuarios",
};
